import { render, staticRenderFns } from "./rmIpfc.vue?vue&type=template&id=6e5227f8"
import script from "./rmIpfc.vue?vue&type=script&lang=js"
export * from "./rmIpfc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports